var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner"},[_c('div',{staticClass:"spinner-box"},[_vm._l((_vm.loadingBN),function(item){return [_c('div',{staticClass:"spinner-container",class:'container'+item},[_vm._l((_vm.loadingNum),function(subItem){return [_c('div',{class:'circle'+subItem,style:({backgroundColor:_vm.color})})]})],2)]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }